import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { forgotPassword } from '../../api/ForgotPasswordInterface';
import Validators from '../../components/Form/InputValidator';
import QueryParamsProxy from '../../utils/queryParamProxy';
import utils from '../../utils';
import Screens from '..';
import { getText, TEXT_KEY } from '../../utils/localization';

var ForgotPassword = /*#__PURE__*/function (_Component) {
  _inherits(ForgotPassword, _Component);

  var _super = _createSuper(ForgotPassword);

  function ForgotPassword(props) {
    var _this;

    _classCallCheck(this, ForgotPassword);

    _this = _super.call(this, props);

    _this.handleSubmit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (Validators.EMAIL(values.email)) {
                  _context.next = 4;
                  break;
                }

                _this.setState({
                  success: false,
                  error: getText(TEXT_KEY.INVALID_EMAIL)
                });

                _context.next = 11;
                break;

              case 4:
                _this.setState({
                  error: null
                });

                _context.next = 7;
                return forgotPassword({
                  email: values.email,
                  platform: utils.getPlatform()
                });

              case 7:
                response = _context.sent;

                if (response) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", false);

              case 10:
                if (!response.success) {
                  _this.setState({
                    success: false,
                    error: response.error
                  });
                } else {
                  QueryParamsProxy.navigate(_this.props.navigation, Screens.Start);
                }

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleCancel = function () {
      QueryParamsProxy.navigate(_this.props.navigation, Screens.Login);
    };

    _this.state = {
      error: null,
      success: false
    };
    return _this;
  }

  _createClass(ForgotPassword, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          success = _this$state.success,
          error = _this$state.error;
      return this.props.render({
        handleCancel: this.handleCancel,
        handleSubmit: this.handleSubmit,
        success: success,
        error: error
      });
    }
  }]);

  return ForgotPassword;
}(Component);

export { ForgotPassword as default };